import omitBy from 'lodash/omitBy';

import adjustUrlParams from './adjustUrlParams';
import isEmptyString from './utils/isEmptyString';

const addTruthyParamsToUrl = (url: string, params = {}) => {
  const activeFields = omitBy(params, isEmptyString);
  return adjustUrlParams(
    currentParams => ({ ...currentParams, ...activeFields }),
    url
  );
};

export default addTruthyParamsToUrl;
